import { AdotelThemeProvider } from '@adotel/components'
import { CssBaseline } from '@material-ui/core'
import moment from 'moment-jalaali'
import { lazy, Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import './App.css'
import RTL from './components/RTL'
import {
  getDirection,
  getIransansFont,
  getLanguage,
  lang
} from './localization'
import PanelRoutes from './routes/panelRoutes'
import Theme from './theme'

getIransansFont()

const PromotionPreview =
  process.env.NODE_ENV === 'development'
    ? lazy(() => import('./dev/PromotionPreview'))
    : null

function MainRoutes() {
  return (
    <>
      <BrowserRouter>
        <PanelRoutes />
      </BrowserRouter>
      <ToastContainer
        position={getDirection() === 'rtl' ? 'bottom-left' : 'bottom-right'}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={getDirection() === 'rtl'}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{ fontFamily: lang === 'fa' ? 'IRANSans' : 'Nunito' }}
      />
    </>
  )
}
localStorage.lang = getLanguage()

if (getLanguage() === 'fa') {
  moment.locale('fa')
  moment.loadPersian({ dialect: 'persian-modern' })
}
function App() {
  const page =
    PromotionPreview && window.location.pathname === '/__promotion-preview' ? (
      <Suspense fallback={null}>
        <PromotionPreview />
      </Suspense>
    ) : (
      <MainRoutes />
    )

  return (
    <AdotelThemeProvider lighttheme={Theme}>
      <CssBaseline />
      <div className="app-container">
        {getDirection() === 'rtl' ? <RTL>{page}</RTL> : page}
      </div>
    </AdotelThemeProvider>
  )
}

export default App
